import styled from 'styled-components';

export const InvestmentAllocationsStyles = styled.div`
	margin-top: 0.5rem;

	.placeholder {
		border: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
		border-radius: 0.5rem;
	}

	.table-wrap {
		overflow: hidden;
		border: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
		border-radius: 0.5rem;
	}
`;
